export default __webpack_public_path__ + "static/media/merath_img.48373631.png";